import React from 'react';
import { useFormContext } from 'react-hook-form';

import { TextArea } from '@infoods/lifebase-ui';

import { ChallengeFormValues } from '../../../../../../interfaces/ChallengeFormValues';
import { STEP_FORM_ID } from '../../GuidedChallengeCreation.settings';
import { validateWhitespace } from '../../../../../../../shared/utils/reactHookFormUtils';

type Props = {
  onNext: () => void;
};

const DescriptionStep = ({ onNext }: Props) => {
  const { control, trigger } = useFormContext<ChallengeFormValues>();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const isValid = await trigger('about.description');

    if (isValid) {
      onNext();
    }
  };

  return (
    <form id={STEP_FORM_ID} onSubmit={onSubmit} noValidate>
      <TextArea
        size="small"
        variant="standard"
        control={control}
        name="about.description"
        label="Description"
        rules={{
          required: 'Description is required',
          validate: { validateWhitespace },
          maxLength: {
            value: 185,
            message: 'Description must be 185 characters or less',
          },
        }}
      />
    </form>
  );
};

export { DescriptionStep };
